export function DestructureSupportDocs(flat: {
    FormOrder: string;
    MarketPlaceSupportDocument: string;
    websiteurl: string;
}): {
    FormOrder: string;
    MarketPlaceSupportDoc: {
        MarketPlaceSupportDocument: string;
        WebSiteURL: string;
    };
}[] {
    const delimeter = '|';
    const formOrders = flat.FormOrder.split(delimeter);
    const documents = flat.MarketPlaceSupportDocument.split(delimeter);
    const urls = flat.websiteurl.split(delimeter);

    const length = Math.max(formOrders.length, documents.length, urls.length);

    const newArray = Array.from({ length }, (_, idx) => ({
        FormOrder: formOrders[idx] || '',
        MarketPlaceSupportDoc: {
            MarketPlaceSupportDocument: documents[idx] || '',
            WebSiteURL: urls[idx] || ''
        }
    }));

    return newArray;
}

const updatedDatasetsSupportDocs = (data: DatasetsResultAction) => {
    const { response } = data;
    let newResponse: UpdatedDatasetResponse[] = [];
    if (response && response.length > 0) {
        newResponse = (response as DataProfileCard[]).map((item: DataProfileCard) => {
            const { FormOrder = '', MarketPlaceSupportDocument = '', websiteurl = '', ...rest } = item;
            if (item.FormOrder && item.MarketPlaceSupportDocument && item.websiteurl) {
                return {
                    ...rest,
                    supportDocs: DestructureSupportDocs({
                        FormOrder: item.FormOrder || '',
                        MarketPlaceSupportDocument: item.MarketPlaceSupportDocument || '',
                        websiteurl: item.websiteurl || ''
                    })
                };
            }
            return { ...rest, supportDocs: [] };
        });
    }
    return { ...data, response: newResponse };
};

export default updatedDatasetsSupportDocs;
